import { Injectable } from "@angular/core";
import { AuthenticationService } from "../services/authentication.service";
import {
    Router,
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";
import { DashboardService } from "../core/services/dashboard.service";

@Injectable()
export class AdminGuardService implements CanActivate {
    constructor(
        private authService: AuthenticationService,
        private router: Router,
        private dashboardService: DashboardService,
    ) {}
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ):
        | boolean
        | UrlTree
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree> {
        const hasRequiredClaims = this.authService.isAdmin();
        if (!hasRequiredClaims) {
            return this.router.createUrlTree(["/unauthorized"]);
        }

        return true;
    }
}
